import { render, staticRenderFns } from "./InsuranceCard.vue?vue&type=template&id=4fd8f956&"
import script from "./InsuranceCard.vue?vue&type=script&lang=js&"
export * from "./InsuranceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports